<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                COMPANY PROFILE
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Company Name</label></b-input-group-prepend>
                        <b-form-input v-model="model.company" :state="!$v.model.company.$error"></b-form-input>
                        <b-input-group-append v-if="(usergroup=='admin')">
                            <b-btn text="Button" @click="lkuCompanyShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Company Address</label></b-input-group-prepend>
                        <b-form-input v-model="model.compaddr1" :state="!$v.model.compaddr1.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                        <b-form-input v-model="model.compaddr2" :state="!$v.model.compaddr2.$error"></b-form-input>
                        <b-form-input v-model="model.compaddr3" class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>City</label></b-input-group-prepend>
                        <b-form-input v-model="model.compcity" :state="!$v.model.compcity.$error"></b-form-input>
                        <b-input-group-prepend><span class="p-2">for Invoice Signature </span></b-input-group-prepend>
                    </b-input-group>
                      <b-input-group>
                          <b-input-group-prepend><label>Phone | Fax </label></b-input-group-prepend>
                          <b-form-input v-model="model.compphone" ></b-form-input>
                          <b-form-input v-model="model.compfax" class="ml-1" placeholder="Fax. Number"></b-form-input>                                        
                      </b-input-group>
                    <b-row class="mt-3" no-gutters>
                        <b-col md="4">
                            <b-input-group >
                                <b-input-group-prepend><label>Local Currency (LCY)</label></b-input-group-prepend>
                                <b-form-select  v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col md="8">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">URL Web App </span></b-input-group-prepend>
                                  <b-form-input v-model="model.compwebsite" :state="!$v.model.compwebsite.$error" style="width:30% !important"></b-form-input>
                                <b-input-group-prepend><span class="p-2">API </span></b-input-group-prepend>
                                  <b-form-input v-model="model.compapi" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >                      
                </b-col>
                <b-col lg="6">
                      <b-card no-body class="overflow-hidden" style="min-height: 250px;">
                        <b-row no-gutters>
                          <b-col md="8">
                            <b-card-body >
                                <b-input-group >
                                    <b-input-group-prepend><label style="width:110px !important;">NPWP</label></b-input-group-prepend>
                                    <b-form-input v-model="model.npwp" :state="!$v.model.npwp.$error"></b-form-input>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label style="width:110px !important;">NPWP Name</label></b-input-group-prepend>
                                    <b-form-input v-model="model.npwp_name" :state="!$v.model.npwp_name.$error"></b-form-input>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label style="width:110px !important;">NPWP Address</label></b-input-group-prepend>
                                    <b-form-input v-model="model.npwp_address" :state="!$v.model.npwp_address.$error"></b-form-input>
                                </b-input-group>
                                <b-row>
                                    <b-col md="6">
                                        <b-input-group >
                                        <b-form-checkbox  class="mt-2" v-model="model.holding" value=1 unchecked-value=0>Holding Company</b-form-checkbox>
                                        </b-input-group>
                                        <b-input-group >
                                        <b-form-checkbox  class="mt-2" v-model="model.use_procure" value=1 unchecked-value=0>Use Procurement Modul</b-form-checkbox>
                                        </b-input-group>
                                        <b-input-group >
                                        <b-form-checkbox  class="mt-2" v-model="model.use_wfservice" value=1 unchecked-value=0>use Workflow Services</b-form-checkbox>
                                        </b-input-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-input-group >
                                        <b-form-checkbox  class="mt-2" v-model="model.iklan" value=1 unchecked-value=0>Advertising Sales</b-form-checkbox>
                                        </b-input-group>
                                        <b-input-group >
                                        <b-form-checkbox  class="mt-2" v-model="model.koran" value=1 unchecked-value=0>News Paper Sales</b-form-checkbox>
                                        </b-input-group>
                                        <b-input-group >
                                            <b-input-group-prepend><span class="pt-2 pr-2">Banner Colour</span></b-input-group-prepend>
                                            <b-form-input v-model="model.compcolor"  type="color" ></b-form-input>
                                            <b-input-group-append> <span class="input-group-text">{{model.compcolor}}</span></b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                            </b-card-body>
                          </b-col>
                          <b-col md="4">
                              <b-row class="justify-content-center mt-1">
                                <div style="width:200px; height:180px; position:relative;" class="border border-primary" v-b-tooltip.hover title="Logo 300x105 pixels">
                                <my-upload field="gambar" :noCircle="true"
                                    @crop-success="cropSuccess"
                                    @crop-upload-success="cropUploadSuccess"
                                    @crop-upload-fail="cropUploadFail"
                                    v-model="showImgTool"
                                    :width="300"
                                    :height="105"
                                    :url="imgUploadUrl"
                                    langType="en"
                                    :params="imgParams"
                                    :headers="imgHeaders"
                                    img-format="png"></my-upload>
                                <img :src="imgDataUrl"  style="width: 198px; position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                                </div>
                              </b-row>
                                <b-row class="justify-content-center mt-1">
                                  <b-button variant="btn btn-primary" @click="toggleShowImg()" v-b-tooltip.hover title="300x105 pixels"> <i class="fa fa-file-image-o"></i> Upload Company Logo</b-button>
                                </b-row>

                          </b-col>
                        </b-row>
                      </b-card>

                </b-col>
            </b-row>
    <b-tabs card>
        <b-tab title="CONFIGURATION #1">
            <b-row >
            <b-col lg="6">
                <b-row>
                    <b-col lg="9">
                            <b-input-group >
                                <b-input-group-prepend><label>VAT IN Account</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.vatInAccount" :state="!$v.model.vatInAccNo.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="showLkuCoa('vatInAcc')" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group >
                                    <b-input-group-prepend><label>VAT OUT Account</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.vatOutAccount" :state="!$v.model.vatOutAccNo.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="showLkuCoa('vatOutAcc')" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                    </b-col>
                    <b-col lg="3">
                            <label>Tarif PPN</label>
                            <b-input-group >
                                <b-form-input  v-model="model.tarifppn" type="number" ></b-form-input>
                                <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                            </b-input-group>
                    </b-col>
                </b-row>
                    <b-input-group >
                            <b-input-group-prepend><label>Bank Charges Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.bankChgAccount" :state="!$v.model.bankChgAccNo.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('bankChgAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Unearned Bank Receipt</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.sunPaymAccount" :state="!$v.model.sunPaymAccNo.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('sunPaymAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
            </b-col>
            <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Advance Return Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.advReturnAccount" :state="!$v.model.advReturnAccNo.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('advReturnAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Advance Additional Acc.</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.advAddionAccount" :state="!$v.model.advAddionAccNo.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('advAddionAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Gain/(Lose) Forex Acc.</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.forexAccount" :state="!$v.model.forexAccNo.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('forexAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Rounded Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.roundAccount" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('roundAcc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
            </b-col>
            </b-row>
            <hr>              
            <b-row >
            <b-col lg="5">
                <b-input-group >
                    <b-input-group-prepend><label>Name of Signer Invoice</label></b-input-group-prepend>
                    <b-form-input v-model="model.invSignNm" :state="!$v.model.invSignNm.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Title of Signer Invoice</label></b-input-group-prepend>
                    <b-form-input v-model="model.invSignTtl" :state="!$v.model.invSignTtl.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Name of Signer Tax</label></b-input-group-prepend>
                    <b-form-input v-model="model.taxSignNm" :state="!$v.model.taxSignNm.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Title of Signer Tax</label></b-input-group-prepend>
                    <b-form-input v-model="model.taxSignTtl" :state="!$v.model.taxSignTtl.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Name of Signer Sales</label></b-input-group-prepend>
                    <b-form-input v-model="model.soSignNm" :state="!$v.model.soSignNm.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Title of Signer Sales</label></b-input-group-prepend>
                    <b-form-input v-model="model.soSignTtl" :state="!$v.model.soSignTtl.$error"></b-form-input>
                </b-input-group>

            </b-col>
            <b-col lg="7">
                <b-card-group deck>
                <b-card class="aging-group">
                    <label style="font-weight:bolder;">AR Customer Aging Grouping</label>
                    <b-form-row class="ml-1" >
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #1</label></b-input-group-prepend>
                            <b-form-input v-model="model.arAge0" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge1" :state="!$v.model.arAge1.$error"  type="number"></b-form-input>
                                <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #2</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge1" disabled></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge2" :state="!$v.model.arAge2.$error"  type="number"></b-form-input>
                                <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #3</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge2" disabled></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge3" :state="!$v.model.arAge3.$error"  type="number"></b-form-input>
                                <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #4</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge3" disabled></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge4" :state="!$v.model.arAge4.$error"  type="number"></b-form-input>
                                <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #5</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge4" disabled></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge5"   type="number"></b-form-input>
                                <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row class="ml-1">
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:70px !important;">Aging #6</label></b-input-group-prepend>
                                <b-form-input v-model="model.arAge5" disabled></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group >
                                <b-input-group-prepend><label>AND MORE </label></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                </b-card>

                <b-card class="aging-group">
                    <label style="font-weight:bolder;">AP Vendor Aging Grouping</label>
                    <b-form-row class="ml-1">
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:70px !important;">Aging #1</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge0" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge1" :state="!$v.model.apAge1.$error"  type="number"></b-form-input>
                            <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                        </b-input-group>
                    </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:70px !important;">Aging #2</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge1" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge2" :state="!$v.model.apAge2.$error"  type="number"></b-form-input>
                            <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                        </b-input-group>
                    </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:70px !important;">Aging #3</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge2" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge3" :state="!$v.model.apAge3.$error"  type="number"></b-form-input>
                            <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                        </b-input-group>
                    </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:70px !important;">Aging #4</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge3" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label  style="width:40px !important;">until</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge4" :state="!$v.model.apAge4.$error"  type="number"></b-form-input>
                            <b-input-group-append><span class="input-group-text"> days</span></b-input-group-append>
                        </b-input-group>
                    </b-col>
                    </b-form-row>
                    <b-form-row class="ml-1">
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:70px !important;">Aging #5</label></b-input-group-prepend>
                            <b-form-input v-model="model.apAge4" disabled></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">days</span></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    <b-col cols="6">
                        <b-input-group >
                            <b-input-group-prepend><label>AND MORE </label></b-input-group-prepend>
                        </b-input-group>
                    </b-col>
                    </b-form-row>
                </b-card>
                </b-card-group>
            </b-col>
            </b-row>
        </b-tab>
        <b-tab title="CONFIGURATION #2">
            <b-row >
                <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label style="width:230px !important">Cashflow IN FLOW Default </label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashinflowInfo" ></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('cashinflow')" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group >
                                <b-input-group-prepend><label style="width:230px !important">Cashflow Revaluation Bank FCY</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflowRevalInfo" ></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('cashflowReval')" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group >
                                <b-input-group-prepend><label style="width:230px !important">Cashflow Bank Internal Transfer</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflowPinbukInfo" ></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('cashflowPinbuk')" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="width:230px !important">#1 Invoice payment Bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.inv_bankName" @keyup.13.native="showLkuBankAccount('satu')" style="width:298px !important;"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuBankAccount('satu')">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Acc.No.</span></b-input-group-prepend>
                            <b-form-input disabled v-model="model.inv_bankAccNo"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="width:230px !important">#2 Invoice payment Bank Account</label></b-input-group-prepend>
                            <b-input-group-append>
                                <b-btn text="Button" @click="clearBankAccount()" class="btn btn-danger"> 
                                    <i class="fa fa-close"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-form-input readonly v-model="model.inv_bankName2" @keyup.13.native="showLkuBankAccount('dua')" style="width:260px !important;"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="showLkuBankAccount('dua')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Acc.No.</span></b-input-group-prepend>
                            <b-form-input disabled v-model="model.inv_bankAccNo2"></b-form-input>
                        </b-input-group>

                </b-col>
                <b-col lg="5">
                        <b-row>
                        <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Prefix AR Invoice</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.prefix_arinv" ></b-form-input>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Prefix Cash Advance</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.prefix_advan" ></b-form-input>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Prefix Expense reimburs</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.prefix_expen" ></b-form-input>
                                </b-input-group>
                            </b-col>
                        <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Prefix Fixed Asset</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.prefix_fa" ></b-form-input>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Prefix Vendor</label></b-input-group-prepend>
                                    <b-form-input  v-model="model.prefix_vendor" ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>    
                </b-col>
            </b-row>
            <hr v-if="(model.koran==1)">              
            <b-row v-if="(model.koran==1)">
                <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Koran Sirkulasi Hotline</label></b-input-group-prepend>
                            <b-form-input  v-model="model.koranhotlinesirkulasi" maxlength="250"></b-form-input>
                        </b-input-group>
                </b-col>
                <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>Koran E-Paper Sales </label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.koransalesEpaperNm" ></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuSalesitem('koransalesEpaper')" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                </b-col>
            </b-row>

        </b-tab>
    </b-tabs>

        <b-row class="justify-content-center mt-4">
            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
            <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </b-row>
        </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="List of Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true" :lazy="true">
            <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuBanktujuanShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-destaccount @click="onSelectLkuBanktujuan"  ></lku-destaccount>
        </b-modal>     
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Sales Items"  :centered="true">
            <lku-item @click="onSelectLkuSalesitem" ></lku-item>
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                width: 160px !important;
            }
        }
    }
    .aging-group {
        .card-body {
            padding: 0 !important;
        }
    }

</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuDestaccount from "../lookup/lkuBankaccountAll";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import lkuCompany from "../lookup/lkuCompany";
import lkuItem from "../lookup/lkuLookupSales";
import crud from "../../apis/crud";
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myUpload,lkuDestaccount, lkuCashflow, lkuCoa, lkuCompany, lkuItem},
  mixins: [validationMixin],
  validations: {
        model: {
          compcode : 		{ required },
          company : 		{ required },
          compaddr1 : 		{ required },
          compaddr2 : 		{ required },
          compcity: {required},
          compphone : 		{ required },
          compwebsite: { required },
          matauang : 		{ required },
          npwp : 		{ required },
          npwp_name : 		{ required },
          npwp_address : 		{ required },
          use_wfservice : 		{ required },
          use_procure : 		{ required },
          holding : 		{ required },
          vatInAccNo : 		{ required },
          vatOutAccNo : 		{ required },
          bankChgAccNo : 		{ required },
          sunPaymAccNo : 		{ required },
          forexAccNo : 		{ required },
          advReturnAccNo : 		{ required },
          advAddionAccNo : 		{ required },
          soSignNm : 		{ required },
          soSignTtl : 		{ required },
          taxSignNm : 		{ required },
          taxSignTtl : 		{ required },
          invSignNm : 		{ required },
          invSignTtl : 		{ required },
          arAge1 : 		{ required },
          arAge2 : 		{ required },
          arAge3 : 		{ required },
          arAge4 : 		{ required },
          apAge1 : 		{ required },
          apAge2 : 		{ required },
          apAge3 : 		{ required },
          apAge4 : 		{ required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,isLoading:false,
        usergroup: this.$store.state.user.group,
        compcode:this.$store.state.user.compcode,
        currency:[{value:'IDR',text:'IDR'}],
        model:{vatInAccNo:'', vatOutAccNo:'',bankChgAccNo :'',sunPaymAccNo :'',forexAccNo :'',advReturnAccNo :'',advAddionAccNo :'', koran:0},
        lkuBanktujuanShow: false,
        lkuBankaccountCaller: 'satu',
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuCoaShow:false,
        lkuCoaCaller:'adv',
        lkuItemShow:false,
        lkuItemCaller:'koransalesEpaper', 
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        showImgTool:false,
        imgParams:{name:'gambar'},
        imgHeaders:{},
        imgDataUrl: '',
        imgUploadUrl: '',
        lkuCompanyShow:false
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
      const [a,b] = await Promise.all([crud.currency(),crud.detail({tablename:'company', key:this.compcode})]) ;
      this.currency = a;
      this.model= b;    
      this.model.vatInAccount = (this.model.vatInAccNo || '').trim() + ' | ' + this.model.vatInAccNm;
      this.model.vatOutAccount = (this.model.vatOutAccNo || '').trim() + ' | ' + this.model.vatOutAccNm;
      this.model.bankChgAccount = (this.model.bankChgAccNo || '').trim() + ' | ' + this.model.bankChgAccNm;
      this.model.sunPaymAccount = (this.model.sunPaymAccNo || '').trim() + ' | ' + this.model.sunPaymAccNm;
      this.model.forexAccount = (this.model.forexAccNo || '').trim() + ' | ' + this.model.forexAccNm;
      this.model.roundAccount = (this.model.roundAccNo || '').trim() + ' | ' + this.model.roundAccNm;
      this.model.advReturnAccount = (this.model.advReturnAccNo || '').trim() + ' | ' + this.model.advReturnAccNm;
      this.model.advAddionAccount = (this.model.advAddionAccNo || '').trim() + ' | ' + this.model.advAddionAccNm;
      this.model.cashinflowInfo = (this.model.cashinflowNo || '').trim() + ' | ' + this.model.cashinflowNm;
      this.model.cashflowRevalInfo = (this.model.cashflowRevalNo || '').trim() + ' | ' + this.model.cashflowRevalNm;
      this.model.cashflowPinbukInfo = (this.model.cashflowPinbukNo || '').trim() + ' | ' + this.model.cashflowPinbukNm;

      this.model.apAge0=0;
      this.model.arAge0=0;
      this.imgDataUrl= this.model.logo;
  },
  methods: {
    clearBankAccount()
    {
        console.log('clearBankAccount');
        this.model.inv_bankkode2='';
        this.model.inv_bankmatauang2='';
        this.model.inv_bankName2='';
        this.model.inv_bankAccNo2='';
    },
    showLkuBankAccount(callerObj)
    {
      this.lkuBanktujuanShow=true;
      this.lkuBankaccountCaller=callerObj;
    },

    onSelectLkuBanktujuan(_selected) {
        this.lkuBanktujuanShow=false;
        if (this.lkuBankaccountCaller=='satu') {
            this.model.inv_bankkode=_selected.kode;
            this.model.inv_bankmatauang=_selected.matauang;
            this.model.inv_bankName=_selected.namabank;
            this.model.inv_bankAccNo=_selected.nomorrek;
        } else {
            this.model.inv_bankkode2=_selected.kode;
            this.model.inv_bankmatauang2=_selected.matauang;
            this.model.inv_bankName2=_selected.namabank;
            this.model.inv_bankAccNo2=_selected.nomorrek;
        }
    },

    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.model[`${this.lkuCoaCaller}ount`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model[`${this.lkuCoaCaller}No`] = _selected.kodeacc;
            this.model[`${this.lkuCoaCaller}Nm`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this.model[`${this.lkuCashflowCaller}Info`] = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this.model[`${this.lkuCashflowCaller}No`] = lkuData.selected.kodecash;
        this.model[`${this.lkuCashflowCaller}Nm`] = lkuData.selected.namacash;
    },
    showLkuSalesitem(callerObj) {
        this.lkuItemShow=true;
        this.lkuItemCaller=callerObj;
    },
    onSelectLkuSalesitem(_selected) {
        this.lkuItemShow=false;
        this.model[`${this.lkuItemCaller}No`] =  _selected.kode;
        this.model[`${this.lkuItemCaller}Nm`] =  _selected.saleCrCode.trim() + " | " + _selected.NamaSale.trim();
    },

    onSelectLkuCompany: async function (_selected) {
      // console.log('user B4 ',this.user);
      if (this.compcode != _selected.compcode) {
          this.isLoading=true;
            this.compcode= _selected.compcode;
            const b = await crud.detail({tablename:'company', key:this.compcode});
            this.model= b;    
            this.model.vatInAccount = (this.model.vatInAccNo || '').trim() + ' | ' + this.model.vatInAccNm;
            this.model.vatOutAccount = (this.model.vatOutAccNo || '').trim() + ' | ' + this.model.vatOutAccNm;
            this.model.bankChgAccount = (this.model.bankChgAccNo || '').trim() + ' | ' + this.model.bankChgAccNm;
            this.model.sunPaymAccount = (this.model.sunPaymAccNo || '').trim() + ' | ' + this.model.sunPaymAccNm;
            this.model.forexAccount = (this.model.forexAccNo || '').trim() + ' | ' + this.model.forexAccNm;
            this.model.advReturnAccount = (this.model.advReturnAccNo || '').trim() + ' | ' + this.model.advReturnAccNm;
            this.model.advAddionAccount = (this.model.advAddionAccNo || '').trim() + ' | ' + this.model.advAddionAccNm;
            this.model.apAge0=0;
            this.model.arAge0=0;
            this.imgDataUrl= this.model.logo;
           this.isLoading=false;
      }
      this.lkuCompanyShow=false;
    },    
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        this.isLoading=true;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;
            this.saveEnabled=true;
        } else {
            try {
              const data = {};
                data.company  =  	 this.model.company ; 
                data.compaddr1  =  	 this.model.compaddr1; 
                data.compaddr2  =  	 this.model.compaddr2; 
                data.compaddr3  =  	 this.model.compaddr3; 
                data.compcity  =  	 this.model.compcity; 
                data.compphone  =  	 this.model.compphone; 
                data.compfax  =  	 this.model.compfax; 
                data.compwebsite  =  	 this.model.compwebsite; 
                data.compapi  =  	 this.model.compapi; 
                data.compcolor  =  	 this.model.compcolor; 
                data.matauang  =  	 this.model.matauang; 
                data.npwp  =  	 this.model.npwp ; 
                data.npwp_name  =  	 this.model.npwp_name; 
                data.npwp_address  =  	 this.model.npwp_address; 
                data.use_wfservice  =  	 this.model.use_wfservice; 
                data.use_procure  =  	 this.model.use_procure; 
                data.holding  =  	 this.model.holding; 
                data.iklan  =  	 this.model.iklan; 
                data.koran  =  	 this.model.koran; 
                data.vatInAccNo  =  	 this.model.vatInAccNo; 
                data.vatInAccNm  =  	 this.model.vatInAccNm; 
                data.vatOutAccNo  =  	 this.model.vatOutAccNo; 
                data.vatOutAccNm  =  	 this.model.vatOutAccNm; 
                data.bankChgAccNo  =  	 this.model.bankChgAccNo; 
                data.bankChgAccNm  =  	 this.model.bankChgAccNm; 
                data.sunPaymAccNo  =  	 this.model.sunPaymAccNo; 
                data.sunPaymAccNm  =  	 this.model.sunPaymAccNm; 
                data.forexAccNo  =  	 this.model.forexAccNo; 
                data.forexAccNm  =  	 this.model.forexAccNm; 
                data.roundAccNo  =  	 this.model.roundAccNo; 
                data.roundAccNm  =  	 this.model.roundAccNm; 
                data.soSignNm  =  	 this.model.soSignNm; 
                data.soSignTtl  =  	 this.model.soSignTtl; 
                data.taxSignNm  =  	 this.model.taxSignNm; 
                data.taxSignTtl  =  	 this.model.taxSignTtl; 
                data.tarifppn  =  	 this.model.tarifppn || 11; 
                data.invSignNm  =  	 this.model.invSignNm; 
                data.invSignTtl  =  	 this.model.invSignTtl; 
                data.arAge1  =  	 this.model.arAge1; 
                data.arAge2  =  	 this.model.arAge2; 
                data.arAge3  =  	 this.model.arAge3; 
                data.arAge4  =  	 this.model.arAge4; 
                data.arAge5  =  	 this.model.arAge5; 
                data.apAge1  =  	 this.model.apAge1; 
                data.apAge2  =  	 this.model.apAge2; 
                data.apAge3  =  	 this.model.apAge3; 
                data.apAge4  =  	 this.model.apAge4; 
                data.advReturnAccNo  =  	 this.model.advReturnAccNo; 
                data.advReturnAccNm  =  	 this.model.advReturnAccNm; 
                data.advAddionAccNo  =  	 this.model.advAddionAccNo; 
                data.advAddionAccNm  = 	 this.model.advAddionAccNm;
                data.logo=this.imgDataUrl;

                data.cashinflowNo  =  	 this.model.cashinflowNo || ''; 
                data.cashinflowNm  =  	 this.model.cashinflowNm || ''; 
                data.cashflowRevalNo  =  	 this.model.cashflowRevalNo || ''; 
                data.cashflowRevalNm  =  	 this.model.cashflowRevalNm || ''; 
                data.cashflowPinbukNo  =  	 this.model.cashflowPinbukNo || ''; 
                data.cashflowPinbukNm  =  	 this.model.cashflowPinbukNm || ''; 
                data.inv_bankkode= this.model.inv_bankkode || '';
                data.inv_bankName= this.model.inv_bankName || '';
                data.inv_bankAccNo= this.model.inv_bankAccNo || '';
                data.inv_bankmatauang= this.model.inv_bankmatauang || '';

                data.inv_bankkode2 = this.model.inv_bankkode2 || '';
                data.inv_bankName2 = this.model.inv_bankName2 || '';
                data.inv_bankAccNo2 = this.model.inv_bankAccNo2 || '';
                data.inv_bankmatauang2 = this.model.inv_bankmatauang2 || '';

                data.prefix_arinv= this.model.prefix_arinv || '';
                data.prefix_fa= this.model.prefix_fa || '';
                data.prefix_vendor= this.model.prefix_vendor || '';
                data.prefix_advan= this.model.prefix_advan || '';
                data.prefix_expen= this.model.prefix_expen || '';
                // data.prefix_vendor= this.model.prefix_vendor || '';

              await crud.update({tablename:'company', key:this.compcode, data});
                toastr.success("Company Profile Saved");                
                this.saveEnabled=true;        
                this.isLoading=false;     
            } catch (error) {
                this.isLoading=false;                
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Company Profile Save Error");   
                this.saveEnabled=true;             
            }
        }
    },
    close(){
          router.push("home");
    },
          toggleShowImg() {
                this.showImgTool = !this.showImgTool;
            },
            /**
             * crop success
             *
             * [param] imgDataUrl
             * [param] field
             */
            cropSuccess(imgDataUrl, field){
                console.log('-------- crop success --------', field);
                this.imgDataUrl=imgDataUrl;
                // console.log(imgDataUrl);
                // console.log('content ',this[field]);
            },
            /**
             * upload success
             *
             * [param] jsonData  server api return data, already json encode
             * [param] field
             */
            cropUploadSuccess(jsonData, field){
                console.log('-------- upload success --------');
                // console.log(jsonData);
                console.log('field: ' + field);
            },
            /**
             * upload fail
             *
             * [param] status    server api return error status, like 500
             * [param] field
             */
            cropUploadFail(status, field){
                console.log('-------- upload fail --------');
                // console.log(status);
                // console.log('field: ' + field);
            }

  }
};
</script>
